import React from 'react'
import { Link } from "react-router-dom";
import { createPopper } from "@popperjs/core";
import { useHistory } from 'react-router-dom';
import { logoutUser } from "components/CommanMethod/Commanmethod";

const QuantityTrackingDropdown = () => {


    const history = useHistory();


    // dropdown props
    const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
    const btnDropdownRef = React.createRef();
    const popoverDropdownRef = React.createRef();
    const openDropdownPopover = () => {
        createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
            placement: "bottom-start",
        });
        setDropdownPopoverShow(true);
    };
    const closeDropdownPopover = () => {
        setDropdownPopoverShow(false);
    };

    //this is the code of the logout click
    const handleLogout = () => {
        logoutUser();
        // Redirect to the login page
        history.push('/login');
    };

    // Retrieve user data from local storage
    const storedUserData = localStorage.getItem('userData');
    let userName = '';
    let userTypeId = '';

    if (storedUserData) {
        const userData = JSON.parse(storedUserData);

        userName = userData.userName;
        userTypeId = userData.userTypeId;
    }


    return (
        <>
            <Link
                className="custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs font-bold"
                href="#"
                ref={btnDropdownRef}
                onMouseOver={(e) => {
                    e.preventDefault();
                    openDropdownPopover();
                }}
                onMouseLeave={(e) => {
                    e.preventDefault();
                    closeDropdownPopover();
                }}
            >
                Quantity Tracker <i class="fa fa-angle-down" aria-hidden="true" style={{margin:'5px'}}></i>
                <div
                    ref={popoverDropdownRef}
                    className={
                        (dropdownPopoverShow ? "block " : "hidden ") +
                        "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
                    }
                >
                    <span
                        className={
                            "custnav text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400"
                        }
                    >
                    </span>




                    <Link
                        to="/getQuantityTraking"
                        className={
                            "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                        }
                    >
                        Quantity  Tracking
                    </Link>
                    
                   {userTypeId === 2&&( <>
                    <Link
                        to="/paymentTraking"
                        className={
                            "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                        }
                    >
                        Payment Tracking
                    </Link>

                    <Link
                        to="/getAllItems"
                        className={
                            "custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                        }
                    >
                        Items Management
                    </Link>
                    </>)}


                </div>
            </Link>


        </>
    )
}

export default QuantityTrackingDropdown
